import requests from "./httpService";
import getEmployeeId from "utils/commonAdmin";


const NotificationServices = {
  addNotification: async (body) => {
    return requests.post("/notification/add", body);
  },

  getAllNotification: async () => {
    const id_employee =await getEmployeeId(); 
    return requests.get(`/notification/getAllNotificationByEmp/${id_employee}`);
  },

  updateStatus: async (id, body) => {
    return requests.put(`/notification/${id}`, body);
  },

  deleteNotification: async (id, body) => {
    return requests.put(`/notification/update/${id}`, body);
  },


  //getNewAllNotification
  getAllNotificationNew:async(id)=>{
    return requests.get(`notification/getAllNotificationByFranchise/${id}`)
  },

  markAsReadNotificationNew:async(id,body)=>{
    return requests.put(`/notification/update/${id}`,body)
  },

  notificationDeleteNew:async(body)=>{
    return requests.delete(`notification/franchise/delete-bulk`,body)
  },
};

export default NotificationServices;
